import { getTheme, mergeStyleSets, Text, Icon } from "@fluentui/react";
import * as React from "react";
import { PropsWithChildren } from "react";

const theme = getTheme();

const style = mergeStyleSets({
	question: [
		theme.fonts.mediumPlus,
		{
			fontWeight: '600',
			paddingTop: '16px',
			lineHeight: '1.4',
			color: theme.palette.neutralPrimary,
		}
	],
	answer: [
		theme.fonts.medium,
		{
			lineHeight: '1.7',
			paddingTop: '4px',
			color: theme.palette.neutralSecondary,
		}
	]
});

export const Question: React.FC<PropsWithChildren<{question: string}>> = (props) => {
	return <>
		<Text className={style.question} block>
			<Icon iconName="FeedbackRequestSolid" style={ {paddingRight: '10px', color: theme.palette.themePrimary }} />
			{props.question}
		</Text>
		<Text className={style.answer} block>
			{props.children}
		</Text>
	</>;
}
